module.exports = __webpack_public_path__ + "img/20180815_150609_097.b331ff55.jpg";